import { render, staticRenderFns } from "./Congratulations.vue?vue&type=template&id=40932d7e&"
import script from "./Congratulations.vue?vue&type=script&lang=ts&"
export * from "./Congratulations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports